import UnderlineNode from './UnderlineNode'
import UnderlineButton from './UnderlineButton'

const TYPE = 'Underline'
const TRIGGER_KEY = 'u'

const hasUnderline = state => state.marks.count() && state.marks.some(mark => mark.type === TYPE)

const UnderlineSchema = {
  marks: {
    Underline: UnderlineNode
  }
}

const onKeyDown = (event, data, state) => {
  if (data.isMod && data.key === TRIGGER_KEY) return onApply(state)
}

const onClickButton = (e, state) => {
  e.preventDefault()
  return onApply(state)
}

const onApply = state => {
  return state
    .transform()
    .toggleMark(TYPE)
    .focus()
    .apply()
}

const UnderlinePlugin = options => {
  return {
    schema: UnderlineSchema,

    onKeyDown (...args) {
      return onKeyDown(...args)
    }
  }
}

export {
  TYPE,
  TRIGGER_KEY,
  hasUnderline,
  onClickButton,
  UnderlinePlugin,
  UnderlineSchema,
  UnderlineNode,
  UnderlineButton
}



// WEBPACK FOOTER //
// ./src/components/UnderlineSlatePlugin/UnderlineSlatePluginContainer.js